<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="125px" :model="formLabelAlign">
      <el-form-item label="推广账户id">
        <el-input v-model="formLabelAlign.account_id" placeholder="请输入推广账户id" />
      </el-form-item>
      <el-form-item label="人群名称">
        <el-input v-model="formLabelAlign.audience_name" placeholder="请输入人群名称" show-word-limit maxlength="32" />
      </el-form-item>
      <el-form-item label="人群描述(选填)">
        <el-input v-model="formLabelAlign.description" placeholder="请输入人群名称" show-word-limit maxlength="100" />
      </el-form-item>
      <el-form-item label="公众号appid">
        <el-input v-model="formLabelAlign.open_app_id" placeholder="请输入公众号appid" />
        <!-- <el-tag v-if="formLabelAlign.open_app_id!=''" class="chosewaccount">{{ appname }}</el-tag>
        <el-button type="warning" size="mini" @click="chooseappid">选择公众号</el-button> -->
      </el-form-item>
      <el-form-item label="上传文件">
        <div>
          <!-- <el-tag
            v-for="tag,index in updata"
            :key="index"
            style="margin-right:10px"
            closable
            @close="close(index)"
          >
            {{ tag.failname }}
          </el-tag> -->
          <el-tag
            v-if="formLabelAlign.file!==''"
            style="margin-right:10px"
          >
            {{ formLabelAlign.file }}
          </el-tag>
        </div>
        <el-button type="warning" size="mini" icon="el-icon-upload2" class="button upload inrew" @click="$refs.file.click()">
          <span>上传人群包文件</span>
          <input ref="file" style="display:none;" type="file" class="file" @change="myChange">
        </el-button>
      </el-form-item>
      <!-- <el-form-item label="深度数据合作">
        <div class="nasrw">
          <el-switch
            v-model="formLabelAlign.cooperate"
            :active-value="1"
            :inactive-value="0"
          />
          <div class="oncarw">{{ formLabelAlign.cooperate === 1 ? '已开启' : '已关闭' }}</div>
        </div>
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary" @click="sumbit">提交</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择公众号"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <officialChoose @official="callback" />
    </el-dialog>
  </div>
</template>

<script>
import * as qiniu from 'qiniu-js'
import { qiniuToken } from '@/api/qiniuToken'
import getNowDate from '@/utils/mixins/convertToHump.js'
import officialChoose from '../../behavioralsource/components/officialChoose.vue'
import { customAudiencesadd } from '@/api/ad.js'
export default {
  components: { officialChoose },
  mixins: [getNowDate],
  data() {
    return {
      type: null,
      labelPosition: 'right',
      formLabelAlign: {
        account_id: '',
        audience_name: '',
        description: '',
        file: '',
        open_app_id: ''
      },
      token: null,
      updata: [],
      dialogVisible: false,
      appname: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type) {
      this.type = type
      this.getQiniuToken()
    },
    getQiniuToken() {
      qiniuToken().then(res => {
        this.token = res.data.upToken
      })
    },
    myChange(event) {
      // const sizemb = (event.target.files[0].size / 1024).toFixed(3)
      // const size = size / 1024// kb
      // size = (size / 1024).toFixed(3)// mb
      const file = event.target.files[0] // 文件信息对象
      // if (file.size > 400000) {
      //   this.$message({
      //     message: '图片必须小于50kb',
      //     type: 'error'
      //   })
      //   return
      // }
      // // 判断是否符合尺寸条件
      // this.isLimitSize(file, 512, 512).then(res => {
      //   this.randomName(file)
      // })
      this.randomName(file)
    },
    randomName(file) {
      const filename = file.name
      // const url = window.URL.createObjectURL(file)
      const fsuiji = Math.random().toString(36).slice(-4) // 随机4位字符串
      const ftype = file.name.substr(file.name.lastIndexOf('.')) // 截取文件格式
      const fname = file.name.substring(0, file.name.lastIndexOf('.')) // 截取文件名
      const timeStamp = new Date() - 0 // 时间戳
      console.log(fsuiji, ftype, fname, timeStamp, filename)
      if (ftype !== '.txt' && ftype !== '.csv' && ftype !== '.zip') {
        this.$message({
          message: '请上传正确的格式(txt,csv,zip)',
          type: 'error'
        })
        return
      }

      this.uploadFile({
        filename,
        file,
        // fileName: 'user/' + fname + '_' + timeStamp + '_' + fsuiji + ftype, // 组合随机文件名
        fileName: `ad/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
        token: this.token,
        putExtra: {
          fname: file.name // 文件名
        },
        config: {
          useCdnDomain: true // cdn域名加速
        }
      })
    },
    // 上传文件
    uploadFile({ filename, file, fileName, token, putExtra = {}, config = {}}) {
      const vm = this
      const observable = qiniu.upload(file, fileName, token, putExtra, config)
      const subscription = observable.subscribe({
        next() {},
        error(err) {
          console.log(err, '====')
          vm.$message({
            message: '上传失败',
            type: 'error'
          })
        },
        complete: (data) => {
          console.log('data', data)
          // this.updata.push({
          //   failname: filename,
          //   failkey: data.key
          // })
          // this.file_namesuccess = filename
          // this.formLabelAlign.file_url = data.key
          this.formLabelAlign.file = data.key
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          console.log(' this.updata', this.updata)
          // const sizekb = Math.ceil(file.size / 1024)
          // // const type = file.type
          // const img = new Image()
          // img.src = window.URL.createObjectURL(file)
          // img.onload = function() {
          //   const query = {
          //     width: img.width,
          //     height: img.height,
          //     size: sizekb,
          //     type: 1,
          //     key: data.key
          //   }
          //   console.log('img.src', img.src, data.key, query)
          //   vm.imgSrc = img.src
          //   vm.qrcode_url = data.key
          //   // vm.brandImageParams.file = query.key
          // }
        }
      }) // 上传开始
      // return subscription.unsubscribe // 返回一个取消上传的方法
      console.log(subscription)
    },
    close(index) {
      console.log(index)
      this.updata.splice(index, 1)
      this.$message({
        message: '删除成功',
        type: 'error'
      })
    },
    async sumbit() {
      if (this.formLabelAlign.account_id === '') {
        this.$message({
          message: '请输入推广账户id',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.audience_name === '') {
        this.$message({
          message: '请输入人群名称',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.open_app_id === '') {
        this.$message({
          message: '请填写公众号appid',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.file === '') {
        this.$message({
          message: '请上传人群包文件',
          type: 'error'
        })
        return
      }
      const data = await customAudiencesadd(this.formLabelAlign)
      this.$emit('updata')
      console.log('data', data)
    },
    // 选择appid 弹窗 加上传值
    chooseappid() {
      this.dialogVisible = true
      // this.$nextTick(() => {
      //   this.$refs.chooseview.send(this.platform)
      // })
    },
    // 选择appid 回调
    callback(item) {
      this.dialogVisible = false
      this.appname = item.account_name
      this.formLabelAlign.open_app_id = item.app_id
      console.log('item', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.oncarw{
  margin-left: 10px;
}
.nasrw{
  display: flex;
  align-items: center;
}
.chosewaccount{
  margin-right: 10px;
}
</style>
